module.exports = __webpack_public_path__ + "static/media/20240319095050_IMG_6048-min.d2aa9d12.JPG";